import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledNameCell = styled(StyledFlex)`
   padding: 8px;
`;
StyledNameCell.displayName = 'StyledNameCell';
